import styled from "styled-components";
import { theme } from "../../theme";

export const NavbarContainer = styled.div`
    height: 6.4rem;
    background-color: #fff;
    padding: 1.6rem 3.8rem;
    display: flex;
    align-items: center;
`;

export const FormContainer = styled.form`
@media (max-width: 564px) {
    display: none;
}
`;

export const IconContainer = styled.div`
    display: none;

    @media (max-width: 920px) {
        display: block;
        align-self: end;
        margin-right: 40px;
        color: ${theme.colors.mainBlue};
        svg {
            width: 24px;
            height: 24px;
        }
    }
`;
export const ActionsContainer = styled.div`
    display: flex;
    align-items: center;
    margin-left: auto;
`;
export const NotificationIconContainer = styled.div`
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.colors.grey03};
    border-radius: 50%;
    color:  ${theme.colors.blackLight};
    margin: 0px 24px;
`;

export const AvatarContainer = styled.div`
    width: 32px;
    height: 32px;
`;